export default class ProfilePermissionService {
  private static instance: ProfilePermissionService;
  private permissions: string[] = [];
  private profile: string = "";

  constructor() {
    const userStorage = localStorage.getItem("user");
    const parsedUser = userStorage ? JSON.parse(userStorage) : null;

    this.permissions =
      parsedUser?.canAccess?.reduce((array: string[], item: any) => {
        if (typeof item.permissions === "string") {
          item.permissions = JSON.parse(item.permissions);
        }

        Object.entries(item.permissions || {}).forEach(([key, value]) =>
          array.push(`${item.module}-${key}:${value}`)
        );

        return array;
      }, []) || [];

    this.profile = parsedUser?.role || "";
  }

  public static getInstance(): ProfilePermissionService {
    if (!ProfilePermissionService.instance) {
      ProfilePermissionService.instance = new ProfilePermissionService();
    }

    return ProfilePermissionService.instance;
  }

  public hasPermission(permissions: string | string[]): boolean {
    if (!Array.isArray(this.permissions)) return false;

    if (Array.isArray(permissions)) {
      return permissions.some((permission: string) =>
        this.permissions.includes(permission)
      );
    }

    return this.permissions.includes(permissions);
  }

  public hasProfile(profiles: string | string[]): boolean {
    if (!this.profile) return false;

    if (Array.isArray(profiles)) {
      return profiles.includes(this.profile);
    }

    return this.profile === profiles;
  }
}
